export const GET_ERRORS = "GET_ERRORS";
export const GET_INFO   = "GET_INFO";
export const GET_STOREDINFO = "GET_STOREDINFO";
export const DELETE_INFO = "DELETE_INFO";
export const GET_INFO_JSON = "GET_INFO_JSON";


//For Education
export const GET_EDUCATION   = "GET_EDUCATION";
export const GET_EDUS   = "GET_EDUS";
export const DELETE_EDU = "DELETE_EDU";

//For Work
export const GET_WORK = "GET_WORK";
export const GET_WORKS = "GET_WORKS";
export const DELETE_WORK = "DELETE_WORK";

//FOr Projects
export const GET_PROJECT = "GET_PROJECT";
export const GET_PROJECTS = "GET_PROJECTS";
export const UPLOAD_TASK = "UPLOAD_TASK";
export const GET_TASKS = "GET_TASKS";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const GET_PROJECTS_JSON = "GET_PROJECTS_JSON";

//For Skills
export const GET_SKILL = "GET_SKILL";
export const GET_SKILLS = "GET_SKILLS";
export const DELETE_SKILL = "DELETE_SKILL";

//Image
export const UPLOAD_PROFILEIMG = "UPLOAD_PROFILEIMG";


export const SET_CURRENT_USER = "SET_CURRENT_USER";